// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.my-modal .modal-content{
    width: 707px;
    border-radius: 20px;
    background-color: #F3F2F0;
}
.my-modal .ModalPosts{
    height: 100%;
    max-height: 350px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color:#707070;
}
.my-modal .ModalFooter{
    margin: auto;
}
.my-modal  .PostCommunity{
    width: 183px;
    height:48px;
    margin-left: 10px;
    border:none;
    border-radius: 20px;
    color:white;
    cursor: pointer;
}
.my-modal .askCommunity{
    background-color: #2168B2;

}
.my-modal .sayCommunity{
    background-color:  #36B549;

}
.my-modal  .Message{
    text-align: center;
    margin-top:200px;
    font-size:20px;
}

.loader{
    width: 60px !important;
    height: 60px !important;
    position: absolute;
    top: 44%;
    left: 44%;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/AsksModal.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;;AAE7B;AACA;IACI,0BAA0B;;AAE9B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb","sourcesContent":["\r\n.my-modal .modal-content{\r\n    width: 707px;\r\n    border-radius: 20px;\r\n    background-color: #F3F2F0;\r\n}\r\n.my-modal .ModalPosts{\r\n    height: 100%;\r\n    max-height: 350px;\r\n    overflow-y: auto;\r\n    scrollbar-width: thin;\r\n    scrollbar-color:#707070;\r\n}\r\n.my-modal .ModalFooter{\r\n    margin: auto;\r\n}\r\n.my-modal  .PostCommunity{\r\n    width: 183px;\r\n    height:48px;\r\n    margin-left: 10px;\r\n    border:none;\r\n    border-radius: 20px;\r\n    color:white;\r\n    cursor: pointer;\r\n}\r\n.my-modal .askCommunity{\r\n    background-color: #2168B2;\r\n\r\n}\r\n.my-modal .sayCommunity{\r\n    background-color:  #36B549;\r\n\r\n}\r\n.my-modal  .Message{\r\n    text-align: center;\r\n    margin-top:200px;\r\n    font-size:20px;\r\n}\r\n\r\n.loader{\r\n    width: 60px !important;\r\n    height: 60px !important;\r\n    position: absolute;\r\n    top: 44%;\r\n    left: 44%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
